<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Edición ítem</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Edición ítem</h6>
    </table>
    <button style="background-color: transparent; color:#10384f;" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="itemForm">
        <div class="container-fluid">
            <div class="row align-items-center">

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.NroLinea}}</mat-label>

                        <input readonly formControlName="nroLinea" type="text" matInput>
                    </mat-form-field>
                </div>


                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field *ngIf="verCantidadDisponible" class="readonly-form-field" color="accent-darker"
                        appearance="outline">
                        <mat-label>{{etiquetaStockDisponible}}</mat-label>
                        <input readonly [value]="cantidadDisponible.value | number : '1.2-2'" type="text" matInput>

                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Cantidad}}</mat-label>
                        <input appThreeDigitDecimaNumber formControlName="cantidad" type="text" matInput>
                        <mat-error *ngIf=" !itemForm.controls['cantidad'].valid && itemForm.get('cantidad').touched">
                            {{Validaciones.Cantidad}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3"
                *ngIf="avisoUnidadesPallet">

                <mat-card class="mat-card-error animate__animated animate__zoomIn animate__faster">

                    <mat-card-content>

                        <p>{{this.mensajeUnidadesPallet}} </p>

                    </mat-card-content>

                </mat-card>
            </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.IdProducto}}</mat-label>
                        <input readonly formControlName="idProducto" type="text" matInput>

                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Producto}}</mat-label>
                        <input readonly formControlName="producto" type="text" matInput>

                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.PrecioUnitarioLista}}</mat-label>
                        <input readonly [value]="itemForm.controls['precioUnitarioLista'].value | number : '1.2-2'"
                            type="text" matInput>

                    </mat-form-field>
                </div>

                <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.PrecioKGL}}</mat-label>
                        <input readonly [value]="itemForm.controls['precioKGL'].value | number : '1.3-3'" type="text"
                            matInput>

                    </mat-form-field>
                </div> -->

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.PrecioUnitarioFinal}}</mat-label>
                        <input readonly
                            [value]="itemForm.controls['precioUnitarioFinal'].value | number:'1.2-2':'es-AR'"
                            type="text" matInput>

                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field [hidden]="!cab.preciosFijos" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.PrecioFinal}}</mat-label>
                        <input appTwoDigitDecimaNumber (blur)="checkPrecioFinal()" formControlName="precioFinal"
                            type="text" matInput>

                        <mat-error
                            *ngIf="!itemForm.controls['precioFinal'].valid && itemForm.get('precioFinal').touched">
                            {{Validaciones.PrecioFinal}}
                        </mat-error>

                    </mat-form-field>
                </div>

                <!-- <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1 mb-1">
                    <mat-divider>
                    </mat-divider>
                </div>

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.DireccionEntrega}}</mat-label>
                        <input (change)="handleEmptyInputDirEntrega($event)" matInput [matAutocomplete]="autoDirEntrega"
                            [formControl]="fcAutocompleteDirEntrega"
                            placeholder="Nro.cliente, nombre, ciudad, calle y nro, etc..">
                        <button type="button" matSuffix mat-icon-button matTooltip="Limpiar dir.entrega seleccionada"
                            (click)="limpiarDirEntrega(true)">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>

                        <mat-autocomplete #autoDirEntrega="matAutocomplete"
                            (optionSelected)='seleccionarDirEntrega($event.option.value)'
                            [displayWith]="getOptionTextDirEntrega">
                            <mat-option *ngIf="loadingFcAutocompleteDirEntrega"
                                class="is-loading">Cargando...</mat-option>
                            <ng-container *ngIf="!loadingFcAutocompleteDirEntrega">
                                <mat-option *ngFor="let de of dirEntregasEncontradas" [value]="de">
                                    {{de.displayValue}}
                                </mat-option>
                            </ng-container>
                        </mat-autocomplete>

                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.NroClienteDireccionEntrega}}</mat-label>

                        <input readonly formControlName="nroClienteDireccionEntrega" type="text" matInput>
                        <mat-error
                            *ngIf="(itemForm.get('nroClienteDireccionEntrega').hasError('required')) && itemForm.get('nroClienteDireccionEntrega').touched">
                            {{Validaciones.DireccionEntrega}}
                        </mat-error>

                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.NombreClienteDireccionEntrega}}</mat-label>

                        <input readonly formControlName="nombreClienteDireccionEntrega" type="text" matInput>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.CalleNroDireccionEntrega}}</mat-label>

                        <input readonly formControlName="calleNroDireccionEntrega" type="text" matInput>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.CPDireccionEntrega}}</mat-label>

                        <input readonly formControlName="cpDireccionEntrega" type="text" matInput>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.CiudadDireccionEntrega}}</mat-label>

                        <input readonly formControlName="ciudadDireccionEntrega" type="text" matInput>
                    </mat-form-field>
                </div> -->



            </div>
        </div>




    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button *ngIf="!isInRole('CONSULTOR')" (click)="guardarItem()" [disabled]="itemForm.invalid" mat-flat-button
        color="accent">Guardar</button>
    <button mat-dialog-close *ngIf="isInRole('CONSULTOR')" mat-flat-button color="accent">Salir</button>

</mat-dialog-actions>